<li  class="navigation-item">
  <div class="menu-section">
    <a class="navigation-link"
       [routerLink]="[route]"
       routerLinkActive="menu-item-active"
       (click)="toggle($event)">
      <span class="icon">
        <svg-icon-sprite
          [src]="icon"
          [width]="'22px'"
        ></svg-icon-sprite>
      </span>
      <span class="title mr-auto left_menu">{{ label }}</span>
    </a>
  
    <div class="menu-body" [class.open]="isOpen">
      <ul class="menu-list">
        <li *ngFor="let child of children">
          <a [routerLink]="child.route"
             routerLinkActive="child-menu-item-active"
             class="navigation-link">
            {{ child.title }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</li>